var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout"},[_c('div',{staticClass:"w-100 relative",attrs:{"id":"viewport"}},[_c('shopping-cart')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }